import { RAILWAY_BUCKET_ENV_KEYS } from '@cli-constants/scaffolding.js'
import { readProjectEnvVar } from '@cli-utils/files.js'

export function hasRailwayBucketConfig(cwd: string): boolean {
  return RAILWAY_BUCKET_ENV_KEYS.every((key) => Boolean(readProjectEnvVar(cwd, key)?.trim()))
}
